export default __webpack_public_path__ + "9de3ac3d48105579fa7b06e64019c6f3.svg";